import React from "react";
import ReactSelect from "react-select";
import { ClearIndicatorStyles } from "./ClearIndicator";

// seconds of 23 hours and 59 minutes to make sure that 00:00 doesn't occur two times
const SECONDS_OF_24H_MINUS_1M = 86340;

interface Props {
  onChange: (time: number) => void;
  value?: number;
  step?: number;
  start?: string;
  format?: number;
  className?: string;
}

export const ReactSelectTimePicker = (props: Props) => {
  const options = values(props.start, props.step).map((value) => {
    return { value: value, label: getStringFromTimeValue(value) };
  });

  return (
    <ReactSelect
      className={props.className}
      isClearable={false}
      isSearchable={false}
      defaultValue={options.find((option) => option.value === props.value)}
      options={options}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "var(--ver-primary-color)",
          primary75: "color-mix(in srgb,var(--ver-primary-color),#0000 25%)",
          primary50: "color-mix(in srgb,var(--ver-primary-color),#0000 50%)",
          primary25: "color-mix(in srgb,var(--ver-primary-color),#0000 75%)",
        },
      })}
      classNames={{
        control: (state) => (state.isFocused ? "border-shadow" : ""),
      }}
      styles={{
        clearIndicator: ClearIndicatorStyles,
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: "var(--ver-input-height)",
          borderRavdius: "var(--bs-border-radius)",
          border: "var(--bs-border-width) solid var(--bs-border-color)",
        }),
      }}
      onChange={(value) => {
        props.onChange((value as any)?.value);
      }}
    ></ReactSelect>
  );
};

const getStringFromTimeValue = (time: number) => {
  if (time === undefined || time > SECONDS_OF_24H_MINUS_1M || time < 0)
    return undefined;
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time / 60) % 60);
  return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}`;
};

const values = (
  start: string | undefined,
  step: number | undefined,
): number[] => {
  if (!start) start = "00:00";
  if (!step) step = 15;
  const regEx = /^(?<hour>[0,1][0-9]|2[0-3]):(?<minute>[0-5][0-9])$/;

  let values: number[] = [];

  if (regEx.test(start)) {
    const hour = parseInt(regEx.exec(start)?.groups?.["hour"] ?? "0");
    const minute = parseInt(regEx.exec(start)?.groups?.["minute"] ?? "00");

    let startTime = hour * 3600 + minute * 60;
    for (; startTime <= SECONDS_OF_24H_MINUS_1M; startTime += step * 60) {
      values.push(startTime);
    }
  }

  return values;
};
